<template>
    <div>
        <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-form-item label="所属门店：">
                    <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" filterable size="small"
                        @change="inputChange">
                        <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                            :key="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="月份">
                    <el-date-picker v-model="dateStr" type="month" size="small"
                        :editable="false" :clearable="false" placeholder="请选择月份" format="yyyy年MM月" @change="dateChange">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="this.$checkBtnPermission('/storeCheck/index', 'viewPage')" size="small"
                        type="primary" class="el-icon-search" @click="inputChange()">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>
            <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading" border stripe>
                <el-table-column slot="monthStr" label="金额" width="100" align="center" fixed="left">
                    <template slot-scope="scope">
                        {{ scope.row.year }}年{{ scope.row.month }}月
                    </template>
                </el-table-column>
            </STable>
            <!-- 分页组件 -->
            <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </topTab>
    </div>
</template>

<script>
import {
    GetMonthStoreProductList
} from "@/api/productApi.js";
import {
    GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
export default {
    data() {
        return {
            activeTab: "1",
            tabData: [
                {
                    key: "1",
                    value: "门店库存盘点",
                },
            ],
            pageShow: true,
            loading: false, // 显示加载
            listData: [],
            selectionList: [],
            // 分页参数
            pageparm: {
                pageIndex: 1,
                pageSize: 10,
                total: 0,
            },
            formInline: {
                pageIndex: 1,
                pageSize: 10,
                storeKeyId: "",
                year: parseInt(new Date().getFullYear()),
                month: parseInt(new Date().getMonth() + 1),
            },
            storeList: [],
            columnsData: [], //显示列
            listColumns: [
                {
                    prop: "rowNumber",
                    label: "序号",
                    align: "center",
                    fixed: "left",
                    width: "80",
                    isKeep: true,
                },
                {
                    slot: "monthStr",
                    label: "月份",
                    minWidth: "100",
                    align: "center",
                },
                {
                    prop: "storeName",
                    label: "门店名称",
                    isKeep: true,
                    minWidth: "120",
                    align: "center",
                },
                {
                    slot: "productInfo.code",
                    label: "商品编码",
                    isKeep: true,
                    minWidth: "170",
                    align: "center",
                    fixed: "left",
                },
                {
                    prop: "productInfo.typeName",
                    label: "类型名称",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "productInfo.productName",
                    label: "商品名称",
                    width: "180",
                    align: "center",
                },
                {
                    prop: "productInfo.specification",
                    label: "规格",
                    width: "150",
                    align: "center",
                },
                {
                    prop: "productInfo.unit",
                    label: "单位",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "price",
                    label: "价格（元）",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "quantity",
                    label: "库存数量",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "creator",
                    label: "盘点人",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "createTime",
                    label: "盘点时间",
                    width: "170",
                    align: "center",
                },
            ],
            dateStr: "",
        };
    },
    // 注册组件
    components: {
    },
    created() {
        // 初始列
        this.getCheckBox(this.listColumns.map((item) => item.label));
        this.GetOrgInfoListByConfig();
        this.dateStr = new Date().getFullYear() + '-' + (new Date().getMonth() + 1);
    },
    computed: {},
    methods: {
        // 获取筛选框
        getCheckBox(val) {
            let arr = this.listColumns.filter((v) => !val.includes(v.label));
            this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
        },
        changePages() { },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        res.data.forEach((item) => {
                            this.storeList.push({
                                keyId: item.keyId,
                                value: item.name + '【' + item.remark2 + '】',
                            });
                        });
                        this.formInline.storeKeyId = this.storeList[0].keyId;
                        this.getListData();
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
        // 获取列表
        getListData() {
            this.loading = true;
            GetMonthStoreProductList(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.loading = false;
                        this.listData = res.data;
                        this.pageparm.total = res.totalNumber;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("数据加载失败，请稍后再试！");
                });
        },
        inputChange(val) {
            this.search();
        },
        // 分页插件事件
        callFather(parm) {
            if (parm.currentPage == undefined) {
                this.formInline.pageIndex = 1;
            } else {
                this.formInline.pageIndex = parm.currentPage;
            }
            this.formInline.pageSize = parm.pageSize;
            this.getListData();
        },
        // 搜索事件
        search() {
            this.formInline.pageIndex = 1;
            this.pageShow = false;
            this.$nextTick(() => {
                this.pageShow = true;
            });
            this.getListData();
        },
        // 月份选择事件
        dateChange() {
            this.formInline.year = this.dateStr.getFullYear();
            this.formInline.month = this.dateStr.getMonth() + 1;
            this.getListData();
        },
    },
};
</script>

<style scoped></style>